document.addEventListener('DOMContentLoaded', function () {
  initPromoCarousel();
});

function initPromoCarousel() {
  const root = document.querySelector('.promo-carousel-simple');
  if (!root) return;

  const track = root.querySelector('#promoTrack');
  const slides = root.querySelectorAll('.promo-carousel-slide');
  const prevBtn = root.querySelector('.promo-carousel-arrow.prev');
  const nextBtn = root.querySelector('.promo-carousel-arrow.next');
  const currentEl = root.querySelector('#currentSlide');
  const totalEl = root.querySelector('#totalSlides');

  if (!track || !slides.length) return;

  let currentIndex = 0;
  const totalSlides = slides.length;

  if (totalEl) totalEl.textContent = totalSlides;

  function update() {
    const slideWidth = track.clientWidth;
    track.scrollTo({
      left: slideWidth * currentIndex,
      behavior: 'smooth'
    });

    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-active', i === currentIndex);
    });

    if (currentEl) currentEl.textContent = currentIndex + 1;

    if (prevBtn) prevBtn.disabled = currentIndex === 0;
    if (nextBtn) nextBtn.disabled = currentIndex === totalSlides - 1;
  }

  function nextSlide() {
    if (currentIndex < totalSlides - 1) {
      currentIndex++;
      update();
    }
  }

  function prevSlide() {
    if (currentIndex > 0) {
      currentIndex--;
      update();
    }
  }

  if (nextBtn) nextBtn.addEventListener('click', nextSlide);
  if (prevBtn) prevBtn.addEventListener('click', prevSlide);

  let startX = 0;
  let isDragging = false;
  let startScrollLeft = 0;
  let moved = false;

  track.addEventListener('mousedown', function (e) {
    isDragging = true;
    moved = false;
    startX = e.pageX;
    startScrollLeft = track.scrollLeft;
    track.classList.add('is-dragging');
  });

  window.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 5) moved = true;
    track.scrollLeft = startScrollLeft - dx;
  });

  window.addEventListener('mouseup', function () {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove('is-dragging');

    const slideWidth = track.clientWidth;
    currentIndex = Math.round(track.scrollLeft / slideWidth);
    if (currentIndex < 0) currentIndex = 0;
    if (currentIndex > totalSlides - 1) currentIndex = totalSlides - 1;

    update();
  });

  let touchStartX = 0;
  let touchMoved = false;

  track.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchMoved = false;
  }, { passive: true });

  track.addEventListener('touchmove', function (e) {
    const dx = e.touches[0].clientX - touchStartX;
    if (Math.abs(dx) > 8) touchMoved = true;
  }, { passive: true });

  track.addEventListener('touchend', function () {
    const slideWidth = track.clientWidth;
    currentIndex = Math.round(track.scrollLeft / slideWidth);
    if (currentIndex < 0) currentIndex = 0;
    if (currentIndex > totalSlides - 1) currentIndex = totalSlides - 1;
    update();
  });

  window.addEventListener('resize', function () {
    update();
  });

  update();
}